const operatorContact = {
	'name': '',
	'email': '',
	'phone': '',
	'company_name': '',
	'company_email': '',
	'company_headquarters': '',
	'company_website': '',
	'company_tin': '',
}

export default {
	data() {
		return {
			entityName: 'operator',
			moduleName: 'operators',
			detailPageRouteName: 'operatorDetail',
			updateFields: [
				'name',
				'note',
				'id_brand',
				'id_business_model',
				'category',
				'active',
				'active_from',
				'active_to',
				'default_subscriber_type_id',
				'default_subscriber_maximum_paired_device_count',
				'default_subscriber_parental_lock_pin',
				'default_pairing_code_expiration_period_in_minutes',
				'can_modify_restricted_device_groups',
				'maximum_user_login_tokens',
				'maximum_epg_view_back_in_hours',
				'maximum_epg_view_forward_in_hours',
				'maximum_subscriber_paired_device_count',
				'maximum_testing_subscriber_count',
				'default_device_language',
				'expire_pvr_on_creation_time',
				'can_add_channels_to_service',
				'can_create_channel_package',
				'can_add_channels_to_own_channel_package',
				'use_global_pvr_storage',
				'contact',
				'shape',
				'contact_email',
				'session_token_expiration_minutes',
				'subscriber_token_expiration_days',
				'maximum_favorite_shows',
				'allow_favorite_shows',
				'ignore_advertisement_settings',
				'tags',
				'allow_geoblocking',
				'geoblocking_country_codes',
				'custom_geoblocking_private_ips',
				'included_device_count',
				'included_firstscreen_device_count',
				'report_subscribers_after_first_month',
				'selfservice_allowed',
				'selfservice_url',
				'selfservice_api_key',
				'delete_unused_device',
				'delete_unused_device_days',
				'subscriber_profile_default_permission_pvrs',
				'subscriber_profile_default_permission_periodic_pvrs',
				'subscriber_profile_default_permission_selfservice',
				'subscriber_profile_default_permission_device_settings',
				'subscriber_profile_default_permission_messages',
				'subscriber_profile_default_permission_channel_groups',
				'subscriber_profile_default_permission_vod',
				'subscriber_profile_default_child_permission_pvrs',
				'subscriber_profile_default_child_permission_periodic_pvrs',
				'subscriber_profile_default_child_permission_selfservice',
				'subscriber_profile_default_child_permission_device_settings',
				'subscriber_profile_default_child_permission_messages',
				'subscriber_profile_default_child_permission_channel_groups',
				'subscriber_profile_default_child_permission_vod',
				'default_subscriber_profile_name',
				'default_child_subscriber_profile_name',
				'create_default_child_subscriber_profile',
				'vod_providers',
				'vod_package_settings',
				'id_currency',
				'subscriber_profile_autoselect_on_new_device',
                'vod_allow_purchase_unprocessed_video',
			],
			entity: {
				'name': '',
				'note': '',
				'logo': null,
				'id_brand': 0,
				'id_business_model': 0,
				'category': 'testing',
				'active': true,
				'active_from': null,
				'active_to': null,
				'default_subscriber_type_id': 1,
				'default_subscriber_maximum_paired_device_count': 4,
				'default_subscriber_parental_lock_pin': 1234,
				'default_pairing_code_expiration_period_in_minutes': 1440,
				'can_modify_restricted_device_groups': 1,
				'maximum_user_login_tokens': 5,
				'maximum_epg_view_back_in_hours': 168,
				'maximum_epg_view_forward_in_hours': 168,
				'maximum_subscriber_paired_device_count': 4,
				'maximum_testing_subscriber_count': 3,
				'default_device_language': 'ces',
				'expire_pvr_on_creation_time': false,
				'can_add_channels_to_service': false,
				'can_create_channel_package': false,
				'can_add_channels_to_own_channel_package': false,
				'use_global_pvr_storage': true,
				'contact': operatorContact,
				'shape': false,
				'contact_email': '',
				'session_token_expiration_minutes': 120,
				'subscriber_token_expiration_days': null,
				'maximum_favorite_shows': null,
				'allow_favorite_shows': null,
				'ignore_advertisement_settings': false,
				'tags': [],
				'allow_geoblocking': false,
				'geoblocking_country_codes': '',
				'custom_geoblocking_private_ips': false,
				'included_device_count': 0,
				'included_firstscreen_count': 0,
				'selfservice_allowed': false,
				'selfservice_url': '',
				'selfservice_api_key': '',
				'delete_unused_device': null,
				'delete_unused_device_days': null,
				'subscriber_profile_default_permission_pvrs': 'OWN',
				'subscriber_profile_default_permission_periodic_pvrs': 'OWN',
				'subscriber_profile_default_permission_selfservice': true,
				'subscriber_profile_default_permission_device_settings': true,
				'subscriber_profile_default_permission_messages': true,
				'subscriber_profile_default_permission_channel_groups': true,
				'subscriber_profile_default_permission_vod': true,
				'subscriber_profile_default_child_permission_pvrs': 'OWN',
				'subscriber_profile_default_child_permission_periodic_pvrs': 'OWN',
				'subscriber_profile_default_child_permission_selfservice': false,
				'subscriber_profile_default_child_permission_device_settings': false,
				'subscriber_profile_default_child_permission_messages': false,
				'subscriber_profile_default_child_permission_channel_groups': false,
				'subscriber_profile_default_child_permission_vod': false,
				'default_subscriber_profile_name': null,
				'default_child_subscriber_profile_name': null,
				'create_default_child_subscriber_profile': null,
				'vod_providers': [],
				'vod_package_settings': {},
				'id_currency': null,
				'subscriber_profile_autoselect_on_new_device': false,
                'vod_allow_purchase_unprocessed_video': false,
			},
			operatorContact: operatorContact,
			allBrands: [],
			allBusinessModels: [],
			subscriberTypes: [],
			uploadReady: true,
			selectedFile: null,
			geoblockingCountryCodes: [],
			reportSubscribersAfterFirstMonth: null,
			businessModelIncludedDeviceCount: 0,
			businessModelIncludedFirstscreenDeviceCount: 0,
			platformCurrency: null,
		}
	},
	computed: {
		operatorActiveOptions() {
			return [
				{id: 'all', text: this.$gettext('Všechny')},
				{id: 'active', text: this.$gettext('Aktivní')},
				{id: 'inactive', text: this.$gettext('Neaktivní')},
			]
		},
	},
	methods: {
		uploadLogo(operatorId) {
			if (this.selectedFile !== null) {
				const formData = new FormData()
				formData.append('uploaded_file', this.selectedFile)

				return this.entityService.uploadLogo(operatorId, formData)
					.then(() => {
						this.selectedFile = null
					})
			}
		},
		prependWithUndefinedOptions(data) {
			data.unshift({'id': '0', 'text': 'Nenastaven'})
			return data
		},
		reloadOperatorsSimpleList() {
			this.entityService.getOperators()
				.then(data => {
					this.setOwnerSetting('operators-simple-list', data.operators)
				})
				.catch(error => {
					this.setErrorMessage(error['error_message'])
				})
		},
		reset() {
			this.setBasicInfoFieldInvalid('operatornameref')
			this.setBasicInfoFieldInvalid('operatorbrandref')
			this.setBasicInfoFieldInvalid('operatorbusinessmodelref')
			this.setBasicInfoFieldInvalid('operatorcategoryref')

			this.setConfigFieldInvalid('defaultparentallockpinref')
			this.setConfigFieldInvalid('defaultsubscribermaxpaireddevicecountref')
			this.setConfigFieldInvalid('maxuserlogintokensref')
			this.setConfigFieldInvalid('defaultpairingcodeexpirationref')
			this.setConfigFieldInvalid('maxepgviewbackref')
			this.setConfigFieldInvalid('maxepgviewforwardref')
			this.setConfigFieldInvalid('canaddchannelstoserviceref')
			this.setConfigFieldInvalid('useglobalpvrstorage')
			this.setConfigFieldInvalid('maxtestingsubscribercountref')
			this.setConfigFieldInvalid('resetpasswordcontactemailref')
		},
		setBasicInfoFieldInvalid(ref, value = false, text = null) {
			this.$refs['operatorbasicinforef'].$refs[ref].setForcedInvalid(value, text)
		},
		setConfigFieldInvalid(ref, value = false, text = null) {
			this.$refs['operatorconfigurationref'].$refs[ref].setForcedInvalid(value, text)
		},
		_processDetailErrorMessage(error) {
			let nameError = null
			let businessModelError = null
			let canAddChannelsToServiceError = null
			let maxTestingSubscribersCountError = null
			let maxEpgViewBackTimeError = null;
			let maxEpgViewForwardTimeError = null;
			let contactEmailError = null;

			this._.forEach(error['validation_errors'], function (errorMessage) {
				if (this._.includes(errorMessage, 'Operator with given name') &&
					this._.includes(errorMessage, 'already exists')) {
					nameError = this.$gettext('Název musí být unikátní')
				}
				if (this._.includes(errorMessage, 'Cannot change business model because of service') &&
					this._.includes(errorMessage, 'with global channel package') &&
					!businessModelError
				) {
					businessModelError = this.$gettext('Nelze změnit business model. Některé služby používají globální balíčky.')
				}
				if (this._.includes(errorMessage, 'Cannot change business model because subscribers') &&
					this._.includes(errorMessage, 'have global services') &&
					!businessModelError
				) {
					businessModelError = this.$gettext('Nelze změnit business model. Někteří odběratelé používají globální služby.')
				}
				if (errorMessage === "Cannot change brand because subscribers' logins would not be unique inside that brand.") {
					error['error_message'] = this.$gettext('Nelze změnit brand - loginy odběratelů by nebyly unikátní uvnitř zvoleného brandu.')
				}
				if (errorMessage === "Cannot forbid adding channels to services. The operator already has services with channels.") {
					error['error_message'] = this.$gettext('Nelze zakázat přidávání kanálů ke službě. Operátor již vytvořil služby s kanály.')
					canAddChannelsToServiceError = true
				}
				if (this._.includes(errorMessage, 'Operator\'s maximum number of testing subscribers') &&
					this._.includes(errorMessage, 'must not be lowered bellow current number of testing subscribers')) {
					maxTestingSubscribersCountError = true
					error['error_message'] = this.$gettext('Nelze nastavit maximální počet testovacích odběratelů na hodnotu nižší než je aktuální počet testovacích odběratelů.')
				}
				if(this._.includes(errorMessage, 'Value max_epg_view_back_in_hours can\'t be bigger then platform max_epg_view_back_in_hours')){
					error['error_message'] = this.$gettext('Nelze nastavit maximální délku zpětného zobrazení EPG na hodnotu vyšší, než je nastavení platformy.')
					maxEpgViewBackTimeError = true
				}
				if(this._.includes(errorMessage, 'Value max_epg_view_forward_in_hours can\'t be bigger then platform max_epg_view_forward_in_hours')){
					error['error_message'] = this.$gettext('Nelze nastavit maximální délku budoucího zobrazení EPG na hodnotu vyšší, než je nastavení platformy.')
					maxEpgViewForwardTimeError = true
				}
				if(this._.includes(errorMessage, 'Configuration\'s \'contact_email\' must be valid email.')){
					error['error_message'] = this.$gettext('E-mail odesílatele při obnově hesla musí být validní emailová adresa.')
					contactEmailError = true;
				}
			}.bind(this))

			if (!this.entity.name) {
				nameError = this.$gettext('Zadejte název')
			} else if (this.entity.name.length < 2) {
				nameError = this.$gettext('Název musí obsahovat min. 2 znaky')
			}

			if (nameError !== null) {
				this.setBasicInfoFieldInvalid('operatornameref', true, nameError)
			} else {
				this.setBasicInfoFieldInvalid('operatornameref')
			}

			if (!this.entity.category || Number(this.entity.category) === 0) {
				this.setBasicInfoFieldInvalid('operatorcategoryref', true, this.$gettext('Zvolte kategorii'))
			} else {
				this.setBasicInfoFieldInvalid('operatorcategoryref')
			}

			if (!this.entity.id_brand || Number(this.entity.id_brand) === 0) {
				this.setBasicInfoFieldInvalid('operatorbrandref', true, this.$gettext('Zadejte brand'))
			} else {
				this.setBasicInfoFieldInvalid('operatorbrandref')
			}

			if (businessModelError !== null) {
				this.setBasicInfoFieldInvalid('operatorbusinessmodelref', true, businessModelError)
			} else {
				this.setBasicInfoFieldInvalid('operatorbusinessmodelref')
			}

			if (!this.entity.id_business_model || Number(this.entity.id_business_model) === 0) {
				this.setBasicInfoFieldInvalid('operatorbusinessmodelref', true, this.$gettext('Zadejte business model'))
			} else {
				this.setBasicInfoFieldInvalid('operatorbusinessmodelref')
			}

			if (!this.entity.default_subscriber_parental_lock_pin && this.entity.default_subscriber_parental_lock_pin !== 0) {
				this.setConfigFieldInvalid('defaultparentallockpinref', true, this.$gettext('Zadejte výchozí hodnotu rodičovského zámku'))
			} else {
				this.setConfigFieldInvalid('defaultparentallockpinref')
			}
			if (!this.entity.default_subscriber_maximum_paired_device_count && this.entity.default_subscriber_maximum_paired_device_count !== 0) {
				this.setConfigFieldInvalid('defaultsubscribermaxpaireddevicecountref', true, this.$gettext('Zadejte výchozí max. počet spárovaných zařízení odběratele'))
			} else {
				this.setConfigFieldInvalid('defaultsubscribermaxpaireddevicecountref')
			}
			if (!this.entity.maximum_user_login_tokens && this.entity.maximum_user_login_tokens !== 0) {
				this.setConfigFieldInvalid('maxuserlogintokensref', true, this.$gettext('Zadejte max. počet přihlášení uživatele'))
			} else {
				this.setConfigFieldInvalid('maxuserlogintokensref')
			}
			if (!this.entity.default_pairing_code_expiration_period_in_minutes && this.entity.default_pairing_code_expiration_period_in_minutes !== 0) {
				this.setConfigFieldInvalid('defaultpairingcodeexpirationref', true, this.$gettext('Zadejte výchozí platnost párovacího kódu'))
			} else {
				this.setConfigFieldInvalid('defaultpairingcodeexpirationref')
			}
			if (!this.entity.maximum_epg_view_back_in_hours && this.entity.maximum_epg_view_back_in_hours !== 0) {
				this.setConfigFieldInvalid('maxepgviewbackref', true, this.$gettext('Zadejte max. délku zpětného zobrazení EPG'))
			} else {
				this.setConfigFieldInvalid('maxepgviewbackref')
			}
			if (!this.entity.maximum_epg_view_forward_in_hours && this.entity.maximum_epg_view_forward_in_hours !== 0) {
				this.setConfigFieldInvalid('maxepgviewforwardref', true, this.$gettext('Zadejte max. délku budoucího zobrazení EPG'))
			} else {
				this.setConfigFieldInvalid('maxepgviewforwardref')
			}
			if (canAddChannelsToServiceError) {
				this.setConfigFieldInvalid('canaddchannelstoserviceref', true)
			} else {
				this.setConfigFieldInvalid('canaddchannelstoserviceref')
			}
			if (maxTestingSubscribersCountError) {
				this.setConfigFieldInvalid('maxtestingsubscribercountref', true)
			} else {
				this.setConfigFieldInvalid('maxtestingsubscribercountref')
			}
			if (maxEpgViewBackTimeError) {
				this.setConfigFieldInvalid('maxepgviewbackref', true)
			} else {
				this.setConfigFieldInvalid('maxepgviewbackref')
			}
			if (maxEpgViewForwardTimeError) {
				this.setConfigFieldInvalid('maxepgviewforwardref', true)
			} else {
				this.setConfigFieldInvalid('maxepgviewforwardref')
			}

			if (contactEmailError) {
				this.setConfigFieldInvalid('resetpasswordcontactemailref', true)
			} else {
				this.setConfigFieldInvalid('resetpasswordcontactemailref')
			}


			return error['error_message']
		},
		_afterUpdateEntityActions() {
			this.reset()
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/operators/mixins/operators.js